module.exports = new __parcel__URL__("GT_P_1Blau_reduziert_006.b7db9e52.json").toString();